import { CmsContentRoot } from '@domgen/dgx-fe-cms';
import { NavigationLink } from '@domgen/dgx-fe-common';
import { YourAppliance } from './cms-your-appliance.interface';

export interface CmsYourAppliancePage extends CmsContentRoot {
  appliances: YourAppliance[];
  articleCategoriesBody: string;
  articleCategoriesTitle: string;
  articleCategoriesViewMoreLink: NavigationLink;
  repairRedirectBody: string;
  repairRedirectIconName: string;
  repairRedirectPrimaryLink: NavigationLink;
  repairRedirectSecondaryLink: NavigationLink;
  repairRedirectTitle: string;
}
